import React, { Component } from 'react';
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import AuthService from '../auth_components/js/AuthService';
import CertificateLanding1 from '../Components/Certificate/CertificateLanding';

class CertificateContainer extends Component {
    constructor(props) {
        super(props);

        let Auth = new AuthService;
        let user = Auth.getUser();
        this.state = {
          username: user.email,
          apikey: user.apikey,
          user: user
        }

    }
    render() {
        return (
            <div>
                <Navbar history={this.props.history} username={this.state.username} apikey={this.state.apikey} />
                <div className="main-body">
                    <CertificateLanding1
                        history={this.props.history}
                        username={this.state.username}
                        user={this.state.user}
                        apikey={this.state.apikey} />
                </div>
            </div>
        )
    }
}

export default withAuth(CertificateContainer);